import { axios, Response } from '../index'

const deleteResponsibleById = (responsibleId: string): Response<null> => {
  return axios.delete(`/v1/responsible/${responsibleId}`)
}

export default deleteResponsibleById
